import Splide from '@splidejs/splide'



document.addEventListener("DOMContentLoaded", function () {
    const sliderElement = document.querySelector('.targetedpeople-block__slidersingle');
    let targetpeople__slider;

    if (sliderElement) {
        function initializeSplide() {
            if (window.innerWidth > 1024) {
                if (!targetpeople__slider) {
                    targetpeople__slider = new Splide('.targetedpeople-block__slidersingle', {
                        type: 'loop',
                        perPage: 4,
                        perMove: 1,
                        gap: '30px',
                        arrows: false,
                        pagination: false,
                    });
                    targetpeople__slider.mount();
                }
            } else {
                if (targetpeople__slider) {
                    targetpeople__slider.destroy(true);
                    targetpeople__slider = null;
                }
            }
        }
        initializeSplide();
        window.addEventListener('resize', initializeSplide);
    }
});
